import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    paper: {
        boxShadow: theme.shadows[8]
    }
}));
